"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmpty = exports.GLOBAL_OBJ = exports.uuidv4 = exports.isMatchArray = exports.stringifyOriginalException = exports.preProcessStack = exports.isErrorObject = void 0;
var constants_1 = require("../constants");
var isErrorObject = function (error) {
    return error instanceof Error;
};
exports.isErrorObject = isErrorObject;
var preProcessStack = function (value) {
    if (!value) {
        return '';
    }
    var result = value;
    for (var _i = 0, _a = Object.values(constants_1.stackMessageRegex); _i < _a.length; _i++) {
        var rule = _a[_i];
        if (rule.test(value)) {
            result = value.replace(rule, '$2');
            break;
        }
    }
    return result;
};
exports.preProcessStack = preProcessStack;
var stringifyOriginalException = function (error) {
    if (!error) {
        return '';
    }
    if (typeof error === 'string') {
        return error;
    }
    try {
        return JSON.stringify(error, typeof error === 'object' ? Object.getOwnPropertyNames(error) : undefined);
    }
    catch (error) {
        return '';
    }
};
exports.stringifyOriginalException = stringifyOriginalException;
var isMatchArray = function (value) { return Array.isArray(value); };
exports.isMatchArray = isMatchArray;
function uuidv4() {
    // 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0, v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
exports.uuidv4 = uuidv4;
function isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
exports.GLOBAL_OBJ = (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
    // eslint-disable-next-line no-restricted-globals
    (typeof window == 'object' && isGlobalObj(window)) ||
    (typeof self == 'object' && isGlobalObj(self)) ||
    (typeof global == 'object' && isGlobalObj(global)) ||
    (function () {
        return this;
    })() ||
    {};
function isEmpty(value) {
    if (value == null) {
        return true;
    }
    if (typeof value === 'object' && value !== null) {
        if (Array.isArray(value)) {
            return value.length === 0;
        }
        if (value instanceof Map || value instanceof Set) {
            return value.size === 0;
        }
        return Object.keys(value).length === 0;
    }
    return false;
}
exports.isEmpty = isEmpty;
